<template>
  <v-alert
    :key="notificationMessageValue.uuid"
    style="margin-top: 4px"
    location="top"
    max-width="300px"
    :color="notificationMessageValue.color"
    :icon="notificationMessageValue.icon"
    variant="elevated"
    closable
    :text="notificationMessage.message"
    prominent
    @click:close="updateMessages(notificationMessageValue.uuid)"
  />
</template>

<script lang="ts" src="./TimeOutAlert.ts"></script>
